<template>
  <v-list v-if="inscricao.arquivos?.length" dense elevation="2">
    <v-list-item v-for="documento in inscricao.arquivos" :key="documento.id">
      <v-list-item-title>{{ getNomeDocumento(documento) }}</v-list-item-title>
      <v-list-item-subtitle>{{
        format(parseISO(documento.data_cadastro), "dd/MM/yyyy HH:mm")
      }}</v-list-item-subtitle>
      <v-list-item-action>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="onClickDocumento(documento)">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Download</span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
  </v-list>

  <v-col v-else-if="pessoa?.conselheiroNome?.length" cols="12" class="pa-0">
    <p class="font-weight-medium">
      Aos cuidados do CONSELHO TUTELAR
    </p>
    <p>
      Conselheiro:
      {{ pessoa?.conselheiroNome || "Não informado" }}
    </p>
  </v-col>

  <span v-else>Nenhum documento encontrado</span>
</template>

<script>
import { format, parseISO } from "date-fns";

const NOME_DOCUMENTO = [
  {
    title: "Declaração ou Carteira de Trabalho (1)",
    label: "declaracao_carteira_trabalho_1",
  },
  {
    title: "Declaração ou Carteira de Trabalho (2)",
    label: "declaracao_carteira_trabalho_2",
  },
  {
    title: "Impossibilidade de férias (1)",
    label: "impossibilidade_ferias1",
  },
  {
    title: "Impossibilidade de férias (2)",
    label: "impossibilidade_ferias2",
  },
  {
    title: "Vulnerabilidade Social (CRAS)",
    label: "vulnerabilidade_social",
  },
  {
    title: "CPF da Criança",
    label: "cpf_crianca",
  },
  {
    title: "Comprovante de Residência",
    label: "comprovante_residencia",
  },
];

export default {
  name: "lista-documentos",

  props: {
    inscricao: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      NOME_DOCUMENTO,
      pessoa: {},
    };
  },

  mounted() {
    this.getPessoa();
  },

  methods: {
    format,
    parseISO,

    async getPessoa() {
      this.pessoa = await this.$erudio
        .get(`/pessoas/${this.inscricao.matricula.pessoa.id}`)
        .catch((error) => this.showMessage(error, "error"));
    },

    onClickDocumento(documento) {
      this.$http
        .get(`/arquivos/plantao-ferias/${documento.caminho}`, {
          responseType: "blob",
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const contentType = blob.type || "application/octet-stream";
          const nomeArquivo = documento.caminho || "arquivo";

          // Se for PDF ou imagem, abre direto na aba
          if (contentType.includes("pdf") || contentType.includes("image")) {
            window.open(url, "_blank");
          } else {
            // Caso contrário, força o download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", nomeArquivo);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }

          // Libera a URL da memória após 10 segundos
          setTimeout(() => URL.revokeObjectURL(url), 10000);
        })
        .catch((error) => {
          this.showMessage(error, "error");
        });
    },

    getNomeDocumento(documento) {
      return (
        this.NOME_DOCUMENTO.find(
          (item) => item.label === documento.nome_arquivo
        )?.title || documento.nome_arquivo
      );
    },
  },
};
</script>
